import { StylingModel } from '../style/styling.model';
import { CoreStylingModel } from '../core/core-styling.model';
/**
 * It is container styling by StylingModel
 */
export class GalleryStylingModel extends CoreStylingModel {
/**
 * @hidden
 * @param {?=} values
 */
constructor(values: Object = {}) {
    super(values);
    Object.assign(this, values);
  }
}
